import johkuWordmark from "../assets/johku-wordmark.png"

/**
 * Pictures from Johku shops' files: a shop's logo and its products' pictures, which Hub knows by
 * the file's name in the shop's files ('193.jpg', see src/files.ts). They load from Johku's files
 * (the CDN in production), resized and cropped there, the way the storefront asks for them.
 */

let filesUrl = "https://cdn.johku.com/"

/** Where Johku serves shops' files (public runtime config johkuFilesUrl, set by plugins/pictures.ts). */
export function setFilesUrl(url: string) {
  if (url) filesUrl = url.replace(/\/?$/, "/")
}

/**
 * A shop's picture at a size (CSS pixels; twice that is asked for sharp screens). crop: filled to
 * the size (photos); otherwise the whole picture fits in it (logos). Null when there's none.
 */
export function shopPicture(
  organisationId: string | null | undefined,
  file: string | null | undefined,
  width: number,
  height = width,
  crop = true,
): string | null {
  const m = file ? /^(\d+)\.[a-z0-9]+$/.exec(file) : null
  if (!m || !organisationId?.startsWith("shop:")) return null
  const shop = encodeURIComponent(organisationId.slice(5))
  return `${filesUrl}${shop}/files/${m[1]}/w${width * 2}-h${height * 2}${crop ? "-s" : ""}/webp/${m[1]}.webp`
}

/** An organisation's avatar picture: the shop's logo, or Johku's wordmark for the Johku team. */
export function organisationLogo(organisation: { id: string; logo?: string } | null | undefined, size: number): string | null {
  if (!organisation) return null
  if (organisation.id === "johku") return johkuWordmark
  return shopPicture(organisation.id, organisation.logo, size, size, false)
}

export { johkuWordmark }
